import { useState, useContext, useEffect } from "react";
import {
  getAllAttributes,
  getAttributeValues,
} from "../ModelServices/ModalServices";
import { AppContext } from "Context/AppContext";
import { TAttribute, TFieldDataConfiguration } from "../model";

type TProp = {
  attributeId: string
}

const useProductAttributeImport = ({attributeId}: TProp) => {
  let appContext = useContext(AppContext);
  let industryId =
    appContext.get_selected_industry() &&
    appContext?.get_selected_industry()?.id;

  const [showAttributeMenu, setShowAttributeMenu] = useState<boolean>(false);
  const [attributeData, setAttributeData] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [selectedAttribute, setSelectedAttribute] = useState<{
    type: string;
    data: TAttribute[];
  } | null>(null);
  const [selectedItems, setSelectedItems] = useState<TAttribute[]>([]);
  const [fieldDataConfiguration, setFieldDataConfiguration] =
    useState<TFieldDataConfiguration>({});
  const openAttributeMenu = () => setShowAttributeMenu(true);

  const filteredAttributeData = attributeData?.filter((item: any) => {
    return item.name.toLowerCase().includes(searchInput.toLowerCase());
  });

  useEffect(() => {
    const fetchAttributeData = async () => {
      if (industryId) {
        const attributeResponse = await getAllAttributes(industryId);
        if (attributeResponse?.done) {
          const attributes = attributeResponse?.data?.map((item: any) => {
            return { name: item?.name, id: item?.id };
          });
          setAttributeData(attributes);
        }
      }
    };
    if (!attributeData || attributeData.length === 0) fetchAttributeData();
  });

  useEffect(() => {
    const fetchAttributeValues = async (attributeId: string) => {
      console.log(attributeId)
      if (attributeId) {
        const attributevaluesResponse = await getAttributeValues(attributeId);
        if (
          attributevaluesResponse?.done &&
          attributevaluesResponse?.data?.length > 0
        ) {
          const attributevalues = attributevaluesResponse?.data?.map(
            (item: any) => {
              return item;
            }
          );
          setFieldDataConfiguration({
            ...fieldDataConfiguration,
            choices: attributevalues,
          });
        }
      }
    };
    if (fieldDataConfiguration?.choices?.length === 0) {
      fetchAttributeValues(
        !["null", null,undefined,"undefined"].includes(attributeId) ? 
      attributeId : 
      fieldDataConfiguration?.attributeId as string);
    }
  }, [fieldDataConfiguration]);

  return {
    showAttributeMenu,
    setShowAttributeMenu,
    attributeData,
    setAttributeData,
    searchInput,
    setSearchInput,
    selectedAttribute,
    setSelectedAttribute,
    selectedItems,
    setSelectedItems,
    fieldDataConfiguration,
    setFieldDataConfiguration,
    filteredAttributeData,
    openAttributeMenu,
  };
};

export default useProductAttributeImport;
